import { BillSubmitAction } from '../../../enums/billSubmitAction'

export const isBillApproveAction = (submitAction?: BillSubmitAction) =>
  submitAction === BillSubmitAction.Approve ||
  submitAction === BillSubmitAction.ApproveBulk ||
  submitAction === BillSubmitAction.ApproveAndClose
